import script from "./ProgressDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressDescription.vue?vue&type=script&setup=true&lang=js"

import "./ProgressDescription.vue?vue&type=style&index=0&id=288c40cf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-288c40cf"]])

export default __exports__